<template>
  <div>
    <el-row>
      <el-col>
        <p>供应商：{{ supplierName }}</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border style="margin-top:20px" :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column label="名字" prop="NAME"></el-table-column>
          <el-table-column label="过期日期" prop="EXPIRE_DATE"></el-table-column>
          <el-table-column label="上传日期" prop="CREATE_TIME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button icon="el-icon-view" size="small" @click="openLicense(scope.row)" type="text">查看资质凭证</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tmpImg: require('@/assets/images/timg.jpg'),
      tableData: [],
      supplierName: sessionStorage.getItem('supplier_T'),
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 6,
        SUPPLIER_ID: this.$route.params.id,
      };
      http.post(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openImg() {
      this.imgFormVisible = true;
    },
    openLicense(row) {
      this.$router.push({ path: `/supplierImg/${row.ID}`, params: { id: row.ID } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tracing/supplierContract.vue